/* eslint-disable */
import {Service} from 'components/Shared/server';
import {AdditionalParameters} from 'models/AdditionalParameters';
import {ProductInstallationZipcodeAvailability} from 'models/ProductInstallationZipcodeAvailability';
import {KitchenContactModel} from 'models/KitchenContactModel';
import {ProductPageModel} from 'models/ProductPageModel';
import {IProductPageExtendedModel} from 'models/IProductPageExtendedModel';
import {ZipcodeAvailability} from 'models/ZipcodeAvailability';


export const routeGetAccessoryDetails = (id: string, category: string) => `/api/product/${encodeURIComponent(id)}/accessory?category=${encodeURIComponent(category)}`;
export function getAccessoryDetails(id: string, category: string): Promise<ProductPageModel> {
  return Service.get<ProductPageModel>({
    url: routeGetAccessoryDetails(id, category)
  });
}

export const routeGetAdditionalData = (productId: string, query?: AdditionalParameters) => Service.appendQueryString(`/api/product/${encodeURIComponent(productId)}/additional`, query);
export function getAdditionalData(productId: string, query: AdditionalParameters): Promise<IProductPageExtendedModel> {
  return Service.get<IProductPageExtendedModel>({
    url: routeGetAdditionalData(productId, query)
  });
}

export const routeGetVariant = (productId: string, variantId: string) => `/api/product/${encodeURIComponent(productId)}/variant/${encodeURIComponent(variantId)}`;
export function getVariant(productId: string, variantId: string): Promise<ProductPageModel> {
  return Service.get<ProductPageModel>({
    url: routeGetVariant(productId, variantId)
  });
}

export const routeGetVariantAdditionalData = (productId: string, variantId: string, query?: AdditionalParameters) => Service.appendQueryString(`/api/product/${encodeURIComponent(productId)}/variant/${encodeURIComponent(variantId)}/additional`, query);
export function getVariantAdditionalData(productId: string, variantId: string, query: AdditionalParameters): Promise<IProductPageExtendedModel> {
  return Service.get<IProductPageExtendedModel>({
    url: routeGetVariantAdditionalData(productId, variantId, query)
  });
}

export const routePostCheckInstallationZipCode = () => `/api/product/installation/checkzipcode/`;
export function postCheckInstallationZipCode(payload: ProductInstallationZipcodeAvailability): Promise<ProductInstallationZipcodeAvailability> {
  return Service.post<ProductInstallationZipcodeAvailability>({
    url: routePostCheckInstallationZipCode(),
    body: payload
  });
}

export const routeGetCheckZipCodeAvailability = (zipCode: string, zipCodeList: string) => `/api/product/installation/checkzipcodeavailability/?zipCode=${encodeURIComponent(zipCode)}&zipCodeList=${encodeURIComponent(zipCodeList)}`;
export function getCheckZipCodeAvailability(zipCode: string, zipCodeList: string): Promise<ZipcodeAvailability> {
  return Service.get<ZipcodeAvailability>({
    url: routeGetCheckZipCodeAvailability(zipCode, zipCodeList)
  });
}

export const routePostKitchenContact = () => `/api/product/kitchencontact/`;
export function postKitchenContact(payload: KitchenContactModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostKitchenContact(),
    body: payload
  });
}
